import { TenantDashboard } from 'app/library/tenant-dashboard/models/tenant-dashboard';
import { User } from 'app/projects/user/src/lib/models/user';
import { ITeamQuery } from '../interfaces/team.query.interface';
import { TeamBreadcrumb } from './team-breadcrumb.model';

export class Team {
    id: string;
    name: string;
    leaders: User[];
    parent: {
        id: string;
        name?: string;
    };
    isSelected?: boolean;
    open: boolean;
    children: Team[] = [];
    charts: TenantDashboard[];
    avgLearningTime: number;
    topThree: User[];
    lowThree: User[];
    watcherCount: number;
    leaderCount: number;
    subteamCount: number;
    memberCount: number;
    isCurrentUserLeader: boolean;
    isCurrentUserMember: boolean;
    isCurrentUserTrainingResponsible: boolean;
    isCurrentUserUpperTrainingResponsible: boolean;
    isCurrentUserWatcher: boolean;
    isCurrentUserTeamLeaderSubteams: boolean;
    breadcrumbs: TeamBreadcrumb[];
    certificateStats: { expiredCount: number; expiringCount: number; totalCount: number };

    constructor(query?: ITeamQuery) {
        if (query) {
            this.id = query.id.toString();
            this.name = query.name;
            this.leaders = query.leaders ? query.leaders.map((leader) => new User(leader)) : null;
            this.parent = query.parent ? { ...query.parent, id: query.parent.id.toString() } : null;
            this.charts = query.charts ? query.charts.map((chart) => new TenantDashboard(chart)) : [];
            this.avgLearningTime = query.avg_learning_time;
            this.topThree = query.top_three ? query.top_three.map((user) => new User(user)) : [];
            this.lowThree = query.low_three ? query.low_three.map((user) => new User(user)) : [];
            this.watcherCount = query.watcher_count;
            this.leaderCount = query.leader_count;
            this.subteamCount = query.subteam_count;
            this.memberCount = query.member_count;
            this.breadcrumbs = query.breadcrumbs?.map((breadcrumb) => new TeamBreadcrumb(breadcrumb));
            this.isCurrentUserLeader = query.my_roles?.includes('team_leader');
            this.isCurrentUserMember = query.my_roles?.includes('team_member');
            this.isCurrentUserTrainingResponsible = query.my_roles?.includes('training_responsible');
            this.isCurrentUserUpperTrainingResponsible = query.my_roles?.includes('upper_training_responsible');
            this.isCurrentUserWatcher = query.my_roles?.includes('team_watcher');
            this.isCurrentUserTeamLeaderSubteams = query.my_roles?.includes('team_leader_sub_teams');
            this.certificateStats = {
                expiredCount: query.certificate_stats?.expired_count,
                expiringCount: query.certificate_stats?.expiring_count,
                totalCount: query.certificate_stats?.total_count,
            };
            this.children = query.children ? query.children.map((team) => new Team(team)) : [];
        }
    }
}
